module.exports = __webpack_public_path__ + "static/media/10_andinvainthedreamer.4cee1679.jpg";